
define('text!templates/modals/claim/goods-collection-item.ejs',[],function () { return '<td><%= fullName %></td>\n<td>\n    <% if (canEdit) { %>\n        <button class="btn btn-mini btn-danger">Удалить</button>\n    <% } %>\n</td>';});

